var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ad7uiv34ya"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.545098 0 0 0 0 0.564706 0 0 0 0 0.603922 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ad7uiv34ya)",
    transform: "translate(-764 -289) translate(342 64) translate(316 212)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81 4.949c.123.148.34.166.485.04.015-.012.029-.025.04-.04l2.667-3.47c.114-.148.088-.363-.057-.48-.06-.046-.132-.072-.206-.072H-.593c-.184 0-.334.153-.334.342 0 .076.025.15.071.21L1.81 4.95z",
    transform: "translate(106 13) translate(3) rotate(-90 2.073 3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81 4.949c.123.148.34.166.485.04.015-.012.029-.025.04-.04l2.667-3.47c.114-.148.088-.363-.057-.48-.06-.046-.132-.072-.206-.072H-.593c-.184 0-.334.153-.334.342 0 .076.025.15.071.21L1.81 4.95z",
    transform: "translate(106 13) rotate(-90 2.073 3)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.28c8189e742f1723dcf7d77be262b748.svg";
export { ForwardRef as ReactComponent };